/** Modifier keys naming an issue's two dates and the span between them. Shared
 *  by the calendar props and the day cell that announces the endpoints. */
export const RANGE_START = "issueRangeStart";
export const RANGE_END = "issueRangeEnd";
export const RANGE_MIDDLE = "issueRangeMiddle";
